"use strict";
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = (this && this.__extends) || (function () {
 var extendStatics = Object.setPrototypeOf ||
 ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
 function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
 return function (d, b) {
 extendStatics(d, b);
 function __() { this.constructor = d; }
 d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
 };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("@firebase/util");
var util_2 = require("./util/util");
var util_3 = require("@firebase/util");
var util_4 = require("@firebase/util");
var util_5 = require("@firebase/util");
var ServerActions_1 = require("./ServerActions");
/**
 * An implementation of ServerActions that communicates with the server via REST requests.
 * This is mostly useful for compatibility with crawlers, where we don't want to spin up a full
 * persistent connection (using WebSockets or long-polling)
 */
var ReadonlyRestClient = /** @class */ (function (_super) {
 __extends(ReadonlyRestClient, _super);
 /**
 * @param {!RepoInfo} repoInfo_ Data about the namespace we are connecting to
 * @param {function(string, *, boolean, ?number)} onDataUpdate_ A callback for new data from the server
 * @param {AuthTokenProvider} authTokenProvider_
 * @implements {ServerActions}
 */
 function ReadonlyRestClient(repoInfo_, onDataUpdate_, authTokenProvider_) {
 var _this = _super.call(this) || this;
 _this.repoInfo_ = repoInfo_;
 _this.onDataUpdate_ = onDataUpdate_;
 _this.authTokenProvider_ = authTokenProvider_;
 /** @private {function(...[*])} */
 _this.log_ = util_2.logWrapper('p:rest:');
 /**
 * We don't actually need to track listens, except to prevent us calling an onComplete for a listen
 * that's been removed. :-/
 *
 * @private {!Object.}
 */
 _this.listens_ = {};
 return _this;
 }
 ReadonlyRestClient.prototype.reportStats = function (stats) {
 throw new Error('Method not implemented.');
 };
 /**
 * @param {!Query} query
 * @param {?number=} tag
 * @return {string}
 * @private
 */
 ReadonlyRestClient.getListenId_ = function (query, tag) {
 if (tag !== undefined) {
 return 'tag$' + tag;
 }
 else {
 util_1.assert(query.getQueryParams().isDefault(), "should have a tag if it's not a default query.");
 return query.path.toString();
 }
 };
 /** @inheritDoc */
 ReadonlyRestClient.prototype.listen = function (query, currentHashFn, tag, onComplete) {
 var _this = this;
 var pathString = query.path.toString();
 this.log_('Listen called for ' + pathString + ' ' + query.queryIdentifier());
 // Mark this listener so we can tell if it's removed.
 var listenId = ReadonlyRestClient.getListenId_(query, tag);
 var thisListen = {};
 this.listens_[listenId] = thisListen;
 var queryStringParamaters = query
 .getQueryParams()
 .toRestQueryStringParameters();
 this.restRequest_(pathString + '.json', queryStringParamaters, function (error, result) {
 var data = result;
 if (error === 404) {
 data = null;
 error = null;
 }
 if (error === null) {
 _this.onDataUpdate_(pathString, data, /*isMerge=*/ false, tag);
 }
 if (util_4.safeGet(_this.listens_, listenId) === thisListen) {
 var status_1;
 if (!error) {
 status_1 = 'ok';
 }
 else if (error == 401) {
 status_1 = 'permission_denied';
 }
 else {
 status_1 = 'rest_error:' + error;
 }
 onComplete(status_1, null);
 }
 });
 };
 /** @inheritDoc */
 ReadonlyRestClient.prototype.unlisten = function (query, tag) {
 var listenId = ReadonlyRestClient.getListenId_(query, tag);
 delete this.listens_[listenId];
 };
 /** @inheritDoc */
 ReadonlyRestClient.prototype.refreshAuthToken = function (token) {
 // no-op since we just always call getToken.
 };
 /**
 * Performs a REST request to the given path, with the provided query string parameters,
 * and any auth credentials we have.
 *
 * @param {!string} pathString
 * @param {!Object.} queryStringParameters
 * @param {?function(?number, *=)} callback
 * @private
 */
 ReadonlyRestClient.prototype.restRequest_ = function (pathString, queryStringParameters, callback) {
 var _this = this;
 if (queryStringParameters === void 0) { queryStringParameters = {}; }
 queryStringParameters['format'] = 'export';
 this.authTokenProvider_
 .getToken(/*forceRefresh=*/ false)
 .then(function (authTokenData) {
 var authToken = authTokenData && authTokenData.accessToken;
 if (authToken) {
 queryStringParameters['auth'] = authToken;
 }
 var url = (_this.repoInfo_.secure ? 'https://' : 'http://') +
 _this.repoInfo_.host +
 pathString +
 '?' +
 util_5.querystring(queryStringParameters);
 _this.log_('Sending REST request for ' + url);
 var xhr = new XMLHttpRequest();
 xhr.onreadystatechange = function () {
 if (callback && xhr.readyState === 4) {
 _this.log_('REST Response for ' + url + ' received. status:', xhr.status, 'response:', xhr.responseText);
 var res = null;
 if (xhr.status >= 200 && xhr.status < 300) {
 try {
 res = util_3.jsonEval(xhr.responseText);
 }
 catch (e) {
 util_2.warn('Failed to parse JSON response for ' +
 url +
 ': ' +
 xhr.responseText);
 }
 callback(null, res);
 }
 else {
 // 401 and 404 are expected.
 if (xhr.status !== 401 && xhr.status !== 404) {
 util_2.warn('Got unsuccessful REST response for ' +
 url +
 ' Status: ' +
 xhr.status);
 }
 callback(xhr.status);
 }
 callback = null;
 }
 };
 xhr.open('GET', url, /*asynchronous=*/ true);
 xhr.send();
 });
 };
 return ReadonlyRestClient;
}(ServerActions_1.ServerActions));
exports.ReadonlyRestClient = ReadonlyRestClient;

//# sourceMappingURL=ReadonlyRestClient.js.map



//////////////////
// WEBPACK FOOTER
// ../database/dist/cjs/src/core/ReadonlyRestClient.js
// module id = 106
// module chunks = 0